import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import BusinessCards from './components/BusinessCards.tsx'

const urlParams = new URLSearchParams(window.location.search);
//const userKey = Number(urlParams.get("userKey")) || 2;
const userKey = Number(urlParams.get("userKey")) || 
                Number(localStorage.getItem('userKey')) || 
                2; // Default value

// Store it for future use if it exists in the URL
if (urlParams.has("userKey")) {
  const userKeyFromUrl = Number(urlParams.get("userKey"));
  if (!isNaN(userKeyFromUrl)) {
    localStorage.setItem('userKey', userKeyFromUrl.toString());
  }
}

//declare global {
//  interface Window {
//    renderBusinessCards: (userKey?: number) => void;
//  }
//}
//
//window.renderBusinessCards = (userKey: number =1) => {
//  const rootElement = document.getElementById("root");
//  const cardsRootElement = document.getElementById("business-cards-root");
//  const renderElement = cardsRootElement || rootElement;
//  console.log("renderElement:", renderElement, ", userKey:", userKey);
//  if (renderElement) {
//    createRoot(renderElement).render(
//      <StrictMode>
//        <BusinessCards userKey={userKey} companyKey={2} companyApiKey="09df728269"/>
//      </StrictMode>,
//    );
//  }
//};
//
//window.renderBusinessCards();
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <div id="modal-root"></div>
    <BusinessCards userKey={userKey} companyKey={2} companyApiKey="09df728269"/>
  </StrictMode>,
)
